import React from "react";
import { Building, Bookmark } from "lucide-react";
import { useSelector } from "react-redux";
import StarRating from "@/components/ui/StarRating";

const PartInfo = ({
  part,
  partName,
  partYear,
  partMakeModel,
  sellerName,
  sellerRating,
  reviewCount,
  onSaveClick,
  isSaved,
  saveLoading,
  removeLoading
}) => {
  const { user, isAuthenticated } = useSelector((state) => state.auth);

  return (
    <div className="p-3 flex-grow">
      <div className="flex justify-between items-center">
        <h3
          className="text-xs sm:text-sm font-semibold mb-0.5 group-hover:text-primary transition-colors truncate leading-tight"
          title={partName}
        >
          {partName}
        </h3>
        {user?.role === "buyer" && isAuthenticated && (
          <button
            onClick={() => onSaveClick(part)}
            disabled={saveLoading || removeLoading}
            className="transition-transform hover:scale-110"
          >
            {isSaved ? (
              <Bookmark className="w-6 h-6 text-primary fill-primary drop-shadow-md" />
            ) : (
              <Bookmark className="w-5 h-5 text-muted-foreground hover:text-primary transition-colors duration-300" />
            )}
          </button>
        )}
      </div>
      <p className="text-[11px] sm:text-xs text-muted-foreground mb-1 truncate">
        {partYear} <br />
        {partMakeModel}
      </p>
      <div className="flex items-center text-[10px] sm:text-[11px] text-muted-foreground mb-1 truncate">
        {part?.sellerLogo ? (
          <img
            src={part?.sellerLogo}
            alt={`${sellerName} logo`}
            className="w-3 h-3 mr-1 rounded-sm object-contain"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextElementSibling.style.display = "inline-block";
            }}
          />
        ) : (
          <Building
            className={`w-3 h-3 mr-1 text-muted-foreground ${
              part?.sellerLogo ? "hidden" : "inline-block"
            }`}
          />
        )}
        {sellerName || "Unknown Seller"}
      </div>
      {sellerRating > 0 && (
        <div className="flex items-center gap-0.5">
          <StarRating rating={sellerRating} size={12} />
          <span className="text-[10px] sm:text-[11px] text-muted-foreground">
            ({reviewCount})
          </span>
        </div>
      )}
    </div>
  );
};

export default PartInfo;
